import { css } from 'linaria';

export const cabinetGallerySectionTabs = css`
  && {
    margin-bottom: 32px;

    @media (--only-mobile) {
      margin-bottom: 24px;
    }
  }
`;


export const cabinetGalleryGrid = css`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 420px 420px auto;
  width: 100%;
  padding: 0;
  margin-bottom: 32px;
  list-style: none;

  li {
    cursor: pointer;
  }

  @media (--from-tablet) {
    :nth-child(1) {
      grid-row: auto / span 2;
    }
  }

  @media (--only-tablet) {
    grid-template-columns: 318px 318px;
    grid-template-rows: 300px 300px auto;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    grid-template-rows: 288px 288px auto;
    margin-bottom: 24px;
    grid-row-gap: 32px;
  }
`;

export const cabinetGalleryImageWrapperWithName = css`
  width: 100%;
  height: 328px;

  @media (--to-desktop) {
    height: 216px;
  }
`;

export const cabinetGalleryImageWrapper = css`
  width: 100%;
  height: 356px;

  @media (--to-desktop) {
    height: 236px;
  }
`;

export const cabinetGalleryFirstImageWrapperWithName = css`
  @media (--from-desktop) {
    height: 772px;
  }

  @media (--only-tablet) {
    height: 540px;
  }
`;

export const cabinetGalleryFirstImageWrapper = css`
  @media (--from-desktop) {
    height: 800px;
  }

  @media (--only-tablet) {
    height: 560px;
  }
`;

export const cabinetGalleryImage = css`
  width: 100%;
  height: 100%;
  border-radius: var(--rounding-l) var(--rounding-l) 0 0;
  object-fit: cover;
`;

export const cabinetGalleryCardContent = css`
  && {
    height: auto;
  }
`;

export const cabinetGallerySectionMoreBtn = css`
  && {
    display: block;
    margin: 0 auto;

    @media (--only-mobile) {
      width: 100%;
      border-radius: var(--rounding-m);
    }
  }
`;